import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { choose: "Elige tu país", search: "Buscar país…", empty: "No se encontraron resultados." },
  en: { choose: "Choose your country", search: "Search country…", empty: "No results found." },
});
